class Tabs {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$tabsMenu = this.$el.find('[data-tabs-menu]');
    this.$tabs = this.$tabsMenu.find('[data-tab]');
    this.$tabContents = this.$el.find('[data-tabs-content]');
    this.$tabContent = this.$tabContents.find('[data-tab]');

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    this.$tabs.on('click', this.onClickTab.bind(this));
  }

  onClickTab(e) {
    e.preventDefault();
    const $tab = $(e.currentTarget);
    const tabId = $tab.data('tab');
    const $tabContent = this.$tabContents.find(`[data-tab="${tabId}"]`);

    this.$tabs.removeClass('active');
    $tab.addClass('active');

    this.$tabContent.removeClass('active');
    $tabContent.addClass('active');
  }

  static init() {
    $('[data-js-component="tabs"]').each((i, el) => new Tabs(el));
  }
}

Tabs.init();
